import React from 'react';
import { Location, Profile } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import { formatPhoneNumber } from './utils';

// Ported one-to-one from @thd-olt-component-react/active-orders' StorePickupDetails.tsx
// (OOP-4059) — see FulfillmentDetailsDrawer.tsx's doc comment.
export interface StorePickupDetailsProps {
  storePickup: any;
}

export const StorePickupDetails: React.FC<StorePickupDetailsProps> = ({ storePickup }) => {
  const store = storePickup?.store;
  const person = storePickup?.pickUpPerson;

  return (
    <div data-testid="store-pickup-address-details">
      <div className="sui-flex sui-p-4">
        <div className="sui-flex sui-flex-row sui-gap-4 sui-pl-2">
          <span className="sui-mt-1">
            <Location size="small" />
          </span>
          <div>
            <Typography variant="h6">Pickup Address</Typography>

            <Typography variant="body-sm">
              {store?.name} #{store?.number}
            </Typography>

            <Typography variant="body-sm">
              {store?.address?.city}, {store?.address?.state} {store?.address?.zipCode}
            </Typography>

            <Typography variant="body-sm">{formatPhoneNumber(store?.phone ?? '')}</Typography>
          </div>
        </div>
      </div>

      <hr className="sui-m-0" />

      <div className="sui-flex sui-p-4">
        <div className="sui-flex sui-flex-row sui-gap-4 sui-pl-2">
          <span className="sui-mt-1">
            <Profile size="small" />
          </span>
          <div>
            <Typography variant="h6">Pickup Person</Typography>

            <Typography variant="body-sm">
              {person?.name?.firstName} {person?.name?.lastName}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
